import { render, staticRenderFns } from "./cert-center.vue?vue&type=template&id=071425c4&scoped=true&"
import script from "./cert-center.vue?vue&type=script&lang=js&"
export * from "./cert-center.vue?vue&type=script&lang=js&"
import style0 from "./cert-center.vue?vue&type=style&index=0&id=071425c4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "071425c4",
  null
  
)

export default component.exports